import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";

const DeleteDCRPage = () => {
  const [states, setStates] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [date, setDate] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => {
        console.error("Error fetching states:", err);
      });
  }, []);

  useEffect(() => {
    if (selectedState) {
      axios
        .get(`${BASE_URL}/api/employees?state_id=${selectedState}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => setEmployees(res.data))
        .catch((err) => {
          console.error(err);
          setEmployees([]);
        });
    } else {
      setEmployees([]);
    }
  }, [selectedState]);

  const handleSubmit = async () => {
    const newErrors = {};
    if (!selectedState) newErrors.state = "Required";
    if (!selectedEmployee) newErrors.employee = "Required";
    if (!date) newErrors.date = "Required";
    if (!password) newErrors.password = "Required";
    setErrors(newErrors);
    setResult(null);

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BASE_URL}/api/dcr-leave-assignments/delete`,
          {
            state_id: selectedState,
            employee_id: selectedEmployee,
            date,
            password,
          },
          { headers: getAuthHeaders() }
        );

        setResult({
          type: "success",
          message: response.data?.message || "DCR deleted successfully.",
        });
      } catch (err) {
        setResult({
          type: "error",
          message:
            err.response?.data?.message ||
            "An error occurred while deleting DCR.",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className=" flex items-start justify-center bg-transparent box-border p-0">
      <div className="w-full  px-4">
        <div className="bg-white border border-gray-800 rounded-md mt-8 mx-auto">
          <div className="w-full flex justify-center py-6">
            <h2 className="text-2xl font-bold text-center">
              <span className="text-blue-700">Select </span>
              <span className="text-blue-500">Employee</span>
            </h2>
          </div>

          <div className="w-full flex justify-center">
            <div className="grid grid-cols-2 gap-7 items-center">
              <div className="flex items-center gap-3">
                <label className="whitespace-nowrap text-sm font-medium text-gray-700">
                  State
                </label>
                <select
                  className="min-w-[320px] w-[320px] px-3 py-2 border border-gray-300 rounded-md bg-white"
                  value={selectedState}
                  onChange={(e) => {
                    setSelectedState(e.target.value);
                    setSelectedEmployee("");
                  }}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Employee */}
              <div className="flex items-center gap-3">
                <label className="whitespace-nowrap text-sm font-medium text-gray-700">
                  Employee
                </label>
                <select
                  className="min-w-[320px] w-[320px] px-3 py-2 border border-gray-300 rounded-md bg-white"
                  value={selectedEmployee}
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.first_name} {emp.last_name}  | {emp.employee} ({emp.designation}|
                      {emp.headquarter_name}|{emp.division}|{emp.state_name})
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Row 1 errors (below) - keeps layout stable */}
          <div className="w-full flex justify-center mt-2">
            <div className="grid grid-cols-2 gap-7">
              <div>
                {errors.state && (
                  <p className="text-red-600 text-xs ml-[90px]">
                    {errors.state}
                  </p>
                )}
              </div>
              <div>
                {errors.employee && (
                  <p className="text-red-600 text-xs ml-[90px]">
                    {errors.employee}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Row 2 : Date | Password */}
          <div className="w-full flex justify-center mt-6">
            <div className="grid grid-cols-2 gap-7 items-center">
              {/* Date */}
              <div className="flex items-center gap-3">
                <label className="whitespace-nowrap text-sm font-medium text-gray-700">
                  Date
                </label>
                <input
                  type="date"
                  className="min-w-[320px] w-[320px] px-3 py-2 border border-gray-300 rounded-md bg-white"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              {/* Password */}
              <div className="flex items-center gap-3">
                <label className="whitespace-nowrap text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  className="min-w-[320px] w-[320px] px-3 py-2 border border-gray-300 rounded-md bg-white"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Row 2 errors (below) */}
          <div className="w-full flex justify-center mt-2">
            <div className="grid grid-cols-2 gap-7">
              <div>
                {errors.date && (
                  <p className="text-red-600 text-xs ml-[90px]">
                    {errors.date}
                  </p>
                )}
              </div>
              <div>
                {errors.password && (
                  <p className="text-red-600 text-xs ml-[90px]">
                    {errors.password}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="w-full flex justify-center mt-8 pb-8">
            <button
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded-md disabled:opacity-60"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Processing..." : "Go"}
            </button>
          </div>

          {result && (
            <div className={`w-full flex justify-center pb-6`}>
              <div
                className={`font-semibold ${
                  result.type === "success" ? "text-green-600" : "text-red-600"
                }`}
              >
                {result.message}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteDCRPage;
